/* eslint-disable no-trailing-spaces,react/jsx-no-bind */
import React from "react";
import Loader from "../loader";
import { DrawMarketHeader } from "../../../helpers/asianHelpers/index";
import AsianGameListCompetition from "../asianGameListCompetition";
import { t } from "../../../helpers/translator";
import { MarketContextProvider } from "./marketContext";
import Config from "../../../config/main";
import GameNotFound from "../gameNotFound";

export default function gameListAsianTemplate() {
	let { data, loaded, sportAlias, onScroll, selectorKey, marketsSelectorKey, gameType, byDayeSort } = this.props;

	if (loaded && data?.length === 0)
		return (
			<div className="no-games">
				<GameNotFound />
			</div>
		);

	if (data?.length && sportAlias !== "boosted" && sportAlias !== "betBuilder") {
		return (
			<div
				id="getScrollPosition"
				className={
					`all-games-list-wrapper scroll-always ${sportAlias}` +
					(loaded ? " loading " : "")
				}
				// eslint-disable-next-line react/jsx-no-bind
				ref={el => (this.scrollGamesListAsian = el)}
				onClick={this.props.uiClose("openRegion")}
				onScroll={this.handleScrollListener}
			>
				<div className="asian-view-wrapper">
					<MarketContextProvider sportAlias={sportAlias} gameType={gameType}>
						<div
							className={`asian-top-row ${sportAlias} ${
								Config.enablePeriodScore
									? (Config.enablePeriodScore &&
											gameType === "prematch") ||
									  gameType === "today" ||
									  gameType === "topGames"
										? ""
										: " four-market"
									: ""
							}`}
						>
							<div className="a-title">
								<div
									className={`market-t-v${
										Config.enablePeriodScore
											? (Config.enablePeriodScore &&
													gameType ===
														"prematch") ||
											  gameType === "today" ||
											  gameType === "topGames"
												? ""
												: " four-market"
											: ""
									}`}
								>
									<label className="checkbox-wrapper-label-text">
										{byDayeSort
											? t("sort by league")
											: t("sort by date")}
										<input
											type="checkbox"
											checked={byDayeSort}
											onChange={
												this
													.hendlerCheckBoxSortDate
											}
										/>
									</label>
								</div>
								<DrawMarketHeader
									gameType={gameType}
									sportAlias={sportAlias}
								/>
								<div className="market-t-v" />
							</div>
						</div>
						<React.Fragment key={byDayeSort}>
							{(() => {
								const outPutData = [];
								for (let i = 0, gameCount = 0; i < data.length; i++) {
									gameCount += data[i][data[i].key].length;
									if (gameCount > this.state.gameLoadCount) {
										outPutData.push(
											<AsianGameListCompetition
												key={
													data[i]
														.regionAlias +
													data[i].key
												}
												competition={{
													...data[i],
													[data[i].key]:
														data[i][
															data[
																i
															]
																.key
														].slice(
															0,
															this
																.state
																.gameLoadCount
														),
												}}
												selectorKey={
													selectorKey
												}
												marketsSelectorKey={
													marketsSelectorKey
												}
												gameType={gameType}
												sportAlias={sportAlias}
											/>
										);
										break;
									}
									outPutData.push(
										<AsianGameListCompetition
											key={
												data[i].regionAlias +
												data[i].key
											}
											competition={data[i]}
											selectorKey={selectorKey}
											marketsSelectorKey={
												marketsSelectorKey
											}
											gameType={gameType}
											sportAlias={sportAlias}
										/>
									);
								}
								return outPutData;
							})()}
						</React.Fragment>
					</MarketContextProvider>
				</div>
				<div className="scroll-b-view-w">
					<div className="single-s-b top-v" onClick={this.scroll(-200)} />
					<div className="single-s-b bot-v" onClick={this.scroll(200)} />
				</div>
			</div>
		);
	} else if (data && (sportAlias === "boosted" || sportAlias === "betBuilder")) {
		return (
			<div
				id="getScrollPosition"
				onScrollCapture={onScroll}
				className={"all-games-list-wrapper scroll-always" + (loaded ? " loading " : "")}
				ref={el => (this.scrollGamesListAsian = el)}
				onClick={this.props.uiClose("openRegion")}
				onScroll={this.handleScrollListener}
			>
				<div className="asian-view-wrapper boosted">
					{data.map(sportType => {
						if (Config.sportListThatCanBeBoostedOdds.includes(sportType.temp)) {
							return (
								<React.Fragment key={sportType.temp}>
									<MarketContextProvider
										sportAlias={sportType.temp}
										gameType={gameType}
									>
										<div
											className={`asian-top-row ${sportType.temp}`}
										>
											<div className="a-title">
												<div className="market-t-v">
													<p className="a-market-name-t">
														{
															sportType
																.data[0]
																.name
														}
													</p>
												</div>
												<DrawMarketHeader
													gameType={
														gameType
													}
													sportAlias={
														sportType.temp
													}
												/>
												<div className="market-t-v" />
											</div>
										</div>
										{(() => {
											data = sportType.data;
											const outPutData = [];
											for (
												let i = 0,
													gameCount = 0;
												i < data.length;
												i++
											) {
												gameCount +=
													data[i][
														data[i]
															.key
													].length;
												if (
													gameCount >
													this.state
														.gameLoadCount
												) {
													outPutData.push(
														<AsianGameListCompetition
															key={
																data[
																	i
																]
																	.regionAlias +
																data[
																	i
																]
																	.key
															}
															competition={{
																...data[
																	i
																],
																[data[
																	i
																]
																	.key]:
																	data[
																		i
																	][
																		data[
																			i
																		]
																			.key
																	].slice(
																		0,
																		this
																			.state
																			.gameLoadCount
																	),
															}}
															selectorKey={
																selectorKey
															}
															marketsSelectorKey={
																marketsSelectorKey
															}
															gameType={
																gameType
															}
															sportAlias={
																sportType.temp
															}
														/>
													);
													break;
												}
												outPutData.push(
													<AsianGameListCompetition
														key={
															data[
																i
															]
																.regionAlias +
															data[
																i
															]
																.key
														}
														competition={
															data[
																i
															]
														}
														selectorKey={
															selectorKey
														}
														marketsSelectorKey={
															marketsSelectorKey
														}
														gameType={
															gameType
														}
														sportAlias={
															sportType.temp
														}
													/>
												);
											}
											return outPutData;
										})()}
									</MarketContextProvider>
								</React.Fragment>
							);
						} else {
							return null;
						}
					})}
				</div>
				<div className="scroll-b-view-w">
					<div className="single-s-b top-v" onClick={this.scroll(-200)} />
					<div className="single-s-b bot-v" onClick={this.scroll(200)} />
				</div>
			</div>
		);
	} else {
		return <Loader component="gameListAsianTemplate" />;
	}
}
